import Vue from 'vue';
import { sleep } from '../commons';

/**
 * Metodos utilitários globais.
 */
Vue.mixin({
    computed: {
        $crud() {
            if (this.$children[0].$options.name === 'CrudView') {
                return this.$children[0].options;
            }
            return null;
        },
    },
    methods: {
        $alert(msg) {
            return new Promise(async(resolve) => {
                if (typeof msg === 'object') {
                    this.$store.commit('ui/ALERT', { ...msg, resolve });
                } else {
                    this.$store.commit('ui/ALERT', { text: msg, resolve });
                }
            });
        },

        $alertMultiples(messages) {
            return new Promise(async(resolve) => {
                const translatedMessages = Array.isArray(messages) ? messages.map(msg => this.$t(msg)) : [this.$t(messages)];
                this.$store.commit('ui/ALERTMULTIPLES', {
                    text: translatedMessages,
                    visible: true,
                    resolve
                });
            });
        },

        async $confirm(msg) {
            return new Promise(async(resolve) => {
                if (typeof msg === 'object') {
                    this.$store.commit('ui/CONFIRM', { ...msg, resolve });
                } else {
                    this.$store.commit('ui/CONFIRM', { text: msg, resolve });
                }
            });
        },

        $notify(msg) {
            this.$store.commit('ui/NOTIFY', msg);
        },

        $sidebarToggle(open) {
            this.$store.commit('ui/SIDEBAR_TOGGLE');
        },

        $quickbarToggle(open) {
            this.$store.commit('ui/QUICKBAR_TOGGLE', open);
        },

        $quickbarOpen(view, options) {
            this.$store.commit('ui/QUICKBAR_OPEN', { view, options });
        },

        async $sleep(ms) {
            return sleep(ms);
        },

        $moment(args) {
            return window.moment(args);
        },

        $clearKeepAlive(viewId) {
            try {
                if (viewId && this.$vnode.parent && this.$vnode.parent.componentInstance) {
                    const keepAlive = this.$vnode.parent.componentInstance;
                    delete keepAlive.cache[viewId];
                    keepAlive.keys = keepAlive.keys.filter((k) => k !== viewId);
                    return;
                }
                throw new Error(`[X] Não foi possível limpar o cache da aba fechada.`);
            } catch (err) {
                console.log(err.message);
            }
        },
    },
});
